export default {
  'monthlyscheduler.instruction': 'Repeat on the',
  'monthlyscheduler.last': '31st/Last Day',
  'monthlyscheduler.endOfMonth': 'End of month',
  'monthlyscheduler.lastWeek': 'Last week',
  'monthlyscheduler.validation.day': 'Day 1 and Day 2 cannot be the same value.'
};
